import { motion } from "framer-motion";
import content from "@/content";

const EASE = [0.22, 1, 0.36, 1];

function MarqueeRow({ names, reverse }) {
  const doubled = [...names, ...names];
  return (
    <div className="overflow-hidden marquee-paused">
      <div className={`flex w-max items-center ${reverse ? "animate-marquee-right" : "animate-marquee-left"}`}>
        {doubled.map((name, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-linen/90 whitespace-nowrap px-8 hover:text-goldsoft transition-colors duration-500">
              {name}
            </span>
            <span className="w-2 h-2 rotate-45 bg-gold/50 shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
}

export default function DesignersMarquee() {
  const d = content.designers;
  const half = Math.ceil(d.names.length / 2);
  const rowA = d.names.slice(0, half);
  const rowB = d.names.slice(half);

  return (
    <section id="designers" data-testid="designers-section" className="relative py-16 lg:py-24 bg-ink texture-grain overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mb-16 text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: EASE }}
          className="text-[11px] uppercase tracking-[0.3em] text-goldsoft mb-6"
        >
          {d.eyebrow}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: EASE, delay: 0.1 }}
          className="font-serif font-light text-4xl sm:text-5xl leading-tight text-linen"
          data-testid="designers-heading"
        >
          {d.heading}
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: EASE, delay: 0.2 }}
          className="mt-6 max-w-xl mx-auto text-sm text-linen/50 leading-relaxed"
        >
          {d.intro}
        </motion.p>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.2, ease: EASE }}
        className="space-y-8"
        data-testid="designers-marquee"
      >
        <MarqueeRow names={rowA} reverse={false} />
        <MarqueeRow names={rowB} reverse={true} />
      </motion.div>
    </section>
  );
}
